import React from "react";
import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { CardWrapper, TabNavigation } from "../ui";
import MethodologyDocButton from "./MethodologyDoc";
import { RiskMonitor } from "./RiskMonitor";
import CustomShocksPage from "./RiskMonitor/CustomShocksPage";
import MabRisk from "./MAB_Risk";
import SpacRisk from "../SpacRisk";
import RiskFrameworkTab from "./RiskFramework/RiskFrameworkTab";

// Risk Framework is the G-Risk home page (/g-risk); G-VaR lives at /g-risk/g-var.
const TABS = [
  { value: "risk-framework", label: "Risk Framework", path: "/g-risk" },
  { value: "g-var", label: "G-VaR", path: "/g-risk/g-var" },
  { value: "custom-shocks", label: "Custom Shocks", path: "/g-risk/custom-shocks" },
  { value: "mab", label: "MAB Risk", path: "/g-risk/mab-risk" },
  { value: "spac", label: "SPAC Risk", path: "/g-risk/spac-risk" },
];

function tabFromPath(pathname) {
  if (pathname.endsWith("/custom-shocks")) return "custom-shocks";
  if (pathname.endsWith("/mab-risk")) return "mab";
  if (pathname.endsWith("/spac-risk")) return "spac";
  if (pathname.endsWith("/g-var")) return "g-var";
  // "/g-risk/risk-framework" is kept as an alias of the home page for existing links.
  return "risk-framework";
}

export default function GRisk() {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = tabFromPath(location.pathname);

  return (
    <Box sx={{ width: "100%" }}>
      <CardWrapper>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <TabNavigation
              tabs={TABS}
              activeTab={activeTab}
              onTabChange={(value) => {
                const next = TABS.find((tab) => tab.value === value);
                if (next && location.pathname !== next.path) navigate(next.path);
              }}
            />
          </Box>
          {activeTab === "g-var" && <MethodologyDocButton />}
        </Box>
      </CardWrapper>
      <Box>
        {activeTab === "g-var" && <RiskMonitor />}
        {activeTab === "custom-shocks" && <CustomShocksPage />}
        {activeTab === "mab" && <MabRisk dashboardOnly />}
        {activeTab === "spac" && <SpacRisk />}
        {activeTab === "risk-framework" && <RiskFrameworkTab />}
      </Box>
    </Box>
  );
}
